<template>
    <div class="campaigns" v-can="'campaign.access'" v-if="isMounted" :class="{isLoad: isLoad}">
        <filter-fields @refresh="refreshFilter">
            <vs-row>
                <vs-col vs-w="12" vs-sm="6" vs-lg="3" vs-xs="12" :key="key" v-for="(value, key) in filtersSystem">
                    <div class="m-2" v-if="!value.input">
                        <label class="text-sm opacity-75">{{$t(`server_filter.${key}`)}}</label>
                        <v-select
                            class="mb-4 md:mb-0"
                            :placeholder="$t(`server_filter.${key}`)"
                            :options="value.options"
                            label="name"
                            :reduce="item => item.id"
                            :selectable="item => item.disabled"
                            v-model="value.select"
                        />
                    </div>

                </vs-col>
                <vs-col vs-w="12" vs-sm="6" vs-lg="3" vs-xs="12">
                    <div class="m-2">
                        <label class="text-sm opacity-75">{{ $t(`global.campaign_identifier`) }}</label>
                        <vs-input
                            class="inputx w-full no_focus"
                            :placeholder="$t('global.campaign_identifier')"
                            v-model="campaign_identifier_system"
                        />
                    </div>
                </vs-col>
                <vs-col vs-w="12">
                    <div class="m-2 flex justify-between items-center">
                        <div>
                            <vs-dropdown ref="dropdown" class="cursor-pointer mr-2" vs-custom-content vs-trigger-click>
                                <a class="flex items-center cursor-pointer" href.prevent>
                                    <feather-icon class="mr-1" icon="SlidersIcon" svgClasses="h-4 w-4 ml-1"/>
                                    <span>{{ $t('global.view') }}</span>
                                </a>

                                <vs-dropdown-menu>
                                    <ul>
                                        <li class="flex items-center" v-for="(h, i) of heads" :key="i">
                                            <vs-button radius color="primary" type="flat" icon-pack="feather" @click="changeDisplay(h)" :icon="h.display ? 'icon-eye' : 'icon-eye-off'"></vs-button>
                                            <span class="ml-2 mr-4 whitespace-no-wrap">{{ $t(h.name) }}</span>
                                        </li>
                                    </ul>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </div>
                        <div>
                            <vs-button :disabled="isLoad" color="primary" @click="submitFilter" type="filled">{{ $t('buttons.Filter') }}</vs-button>
                        </div>
                    </div>
                </vs-col>
            </vs-row>
        </filter-fields>

        <ds-table
            ref="table"
            :data="campaigns"
            :heads="heads"
            :max-items="limitNum"
            :total="meta.total"
            :view-items="views"
            :page="pageNum"
            ssr
            expand
            :to-data-text="$t('global.No_data')"
            @limit="limit"
            @page="page"
            @sort="sort"
        >
            <template v-slot:header>
                <vs-button v-can="'campaign.create'" @click="addCampaign" class="mr-4 whitespace-no-wrap" color="primary" type="border" v-bind="$iconData('icon-plus', 'fi-rr-plus')">
                    {{$t('buttons.Create_campaign')}}
                </vs-button>
            </template>

            <template v-slot:name="{name}">
                <div class="flex items-center">
                    <div class="flex items-center">
                        <vs-icon v-if="name.cloack_type" v-tooltip="name.cloack_type" size="20px" v-bind="$iconData('icon-shield', 'fi-rs-shield')" color="success" class="mr-2"/>
                        <vs-icon v-else size="20px" v-bind="$iconData('icon-shield-off', 'fi-rr-shield-slash')" color="danger" class="mr-2"/>
                    </div>
                    <div>
                        <div class="text-xs uppercase ind_color" v-if="name.campaign_type">{{ name.campaign_type }}
                        </div>
                        <div>{{ name.campaign_name }}</div>
                        <div class="flex items-center" v-if="name.campaign_identifier">
                            <div class="text-xs ind_color">{{ name.campaign_identifier }}</div>
                            <vs-icon class="ml-2 cursor-pointer" color="primary" v-tooltip="$t('tooltip.Copy')"
                                     @click.stop.prevent="copy(name.campaign_identifier)" v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"/>
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:language="{language}">
                <div v-if="language.language" class="lang product-name font-medium truncate flex">
                    <div class="flex items-center">
                        <flag width="25" type="language" :iso="language.language"/>
                        <div class="ml-2">
                            <div class="text-xs" style="color: gray; font-size: 9px;"></div>
                            <div>{{ _lang(language.language).label }}</div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p class="product-name font-medium truncate">-</p>
                </div>
            </template>

            <template v-slot:affiliate="{affiliate}">
                <div>{{ affiliate.affiliate_name ? affiliate.affiliate_name : '-' }}</div>
                <div class="flex items-center"
                     v-if="affiliate.campaign_type === 'api' ? affiliate['x-secret-key'] : affiliate.affiliate_hash">
                    <div class="text-xs ind_color">
                        {{ affiliate.campaign_type === 'api' ? affiliate['x-secret-key'] : affiliate.affiliate_hash }}
                    </div>
                    <vs-icon class="ml-2 cursor-pointer" color="primary" v-tooltip="$t('tooltip.Copy')"
                             @click.stop.prevent="copy(affiliate.campaign_type === 'api' ? affiliate['x-secret-key'] : affiliate.affiliate_hash)"
                             v-bind="$iconData('icon-copy', 'fi-rr-copy-alt')"/>
                </div>
            </template>

            <template v-slot:team="{team}">
                <div class="flex items-center whitespace-no-wrap">
                    <vs-icon color="primary" v-bind="$iconData('icon-users', 'fi-rr-users')"/>
                    <div class="ml-2">{{ team.team_name ? team.team_name : '-' }}</div>
                </div>
            </template>

            <template v-slot:domains="{domains}">
                <div class="flex justify-center">
                    <vs-chip v-tooltip.position.left="domains.domainsList.join('<br>')">
                        <vs-avatar color="#f0f0f0" text-color="#175ea5" v-bind="$iconData('icon-link', 'fi-rr-link-alt')"/>
                        <span>{{ domains.domainsList.length }}</span>
                    </vs-chip>
                </div>
            </template>

            <template v-slot:status="{status}">
                <div class="flex justify-center">
                    <vs-switch v-can="'campaign.destroy'" color="success" v-model="status.is_active" @click.stop.prevent="changeStatus(status)"
                               icon-pack="feather" vs-icon-off="icon-x"
                               vs-icon-on="icon-check"/>
                    <vs-switch v-can:show="'campaign.destroy'" color="success" disabled icon-pack="feather"
                               v-model="status.is_active" vs-icon-off="icon-x" vs-icon-on="icon-check"/>
                </div>
            </template>

            <template v-slot:approve="{approve}">
                <div class="flex justify-center">
                    <vs-switch v-can="'campaign.approve'" color="success" v-model="approve.is_approved" @click.stop.prevent="changeApprove(approve)"
                               :disabled="!!approve.is_approved"
                               icon-pack="feather" vs-icon-off="icon-x"
                               vs-icon-on="icon-check"/>
                    <vs-switch v-can:show="'campaign.approve'" color="success" disabled icon-pack="feather"
                               v-model="approve.is_approved" vs-icon-off="icon-x" vs-icon-on="icon-check"/>
                </div>
            </template>

            <template v-slot:actions="{actions}">
                <div class="flex justify-center">
                    <vs-button @click.stop.prevent="getCode(actions)" v-tooltip="$t('global.Information')" radius color="primary" type="flat" v-bind="$iconData('icon-info', 'fi-rr-info')"></vs-button>
                    <vs-button v-can="'campaign.update'" @click.stop.prevent="editCampaign(actions)" v-tooltip="$t('modals.Edit_campaign')" radius color="primary" type="flat" v-bind="$iconData('icon-edit', 'fi-rr-file-edit')"></vs-button>
                    <vs-button v-can:show="'campaign.update'" disabled radius color="primary" type="flat" v-bind="$iconData('icon-edit', 'fi-rr-file-edit')"></vs-button>
                    <vs-button :disabled="!actions.domainsList.length" @click.stop.prevent="downloadDomains(actions)" v-tooltip="$t('tooltip.Download_list_domains')" radius color="primary" type="flat" v-bind="$iconData('icon-download', 'fi-rr-download')"></vs-button>
                </div>
            </template>

            <template v-slot:expand="{expand}">
                <DetailsDomains :data="expand.domainsList"></DetailsDomains>
            </template>
        </ds-table>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import ErrorHandler from "@/utils/errorHandler"
import {copy, download} from '@/utils/utils'
import EventBus from "@/store/eventBus"
import send from "@/utils/fetch"
import DetailsDomains from './DetailsDomains'
import {flag, utils} from '@/utils/mixins'
import light from "echarts/src/theme/light";

export default {
    mixins: [flag, utils],
    data() {
        return {
            isMounted: false,
            isLoad: true,
            limitNum: 50,
            pageNum: 1,
            sortName: {},
            views: [50, 100, 500],
            filtersSystem: {},
            filters: {},
            campaign_identifier: '',
            campaign_identifier_system: '',
            heads: [
                {name: 'global.Name', key: 'name', sortKey: 'campaign_name', value: 'name', display: true},
                {name: 'global.Language', key: 'language', sortKey: 'language', value: 'language', display: true},
                {name: 'global.Affiliate', key: 'affiliate', sortKey: 'affiliate_name', value: 'affiliate', display: true},
                {name: 'global.Team', key: 'team', sortKey: 'team_name', value: 'team', display: true},
                {name: 'global.Landing', key: 'landing_name', sortKey: 'landing_name', value: 'landing_name', display: true},
                {name: 'global.Offer', key: 'offer_name', sortKey: 'offer_name', value: 'offer_name', display: true},
                {name: 'global.Domains', key: 'domains', sortKey: 'domains', value: 'domains', display: true, center: true},
                {name: 'global.Status', key: 'status', sortKey: 'is_active', value: 'status', display: true, center: true},
                {name: 'campaigns.Approve', key: 'is_approved', sortKey: 'is_approved', value: 'approve', display: true, center: true},
                {name: 'global.Actions', key: 'actions', value: 'actions', display: true, center: true},
            ],
            campaignsList: [],
            meta: [],
            timeout: null
        }
    },

    components: {
        vSelect,
        DetailsDomains
    },

    computed: {
        campaigns() {
            return this.campaignsList
        }
    },

    methods: {
        _lang(lang) {
            const flag = this.getFlag(lang)

            return {
                label: lang.toUpperCase(),
                flag: flag,
                value: lang.toLowerCase()
            }
        },

        _notification(title, text, status, icon) {
            this.$vs.notify({ title: title, text: text, color: status, iconPack: 'feather', icon: icon })
        },

        async limit(limit) {
            if (limit !== this.limitNum) {
                this.pageNum = 1
                this.limitNum = limit
                await this.get()
            }
        },

        async page(page) {
            if (page !== this.pageNum) {
                this.pageNum = page
                await this.get()
            }
        },

        async sort(data) {
            if (data.type) {
                this.sortName = {[`order_by[${data.name}]`]: data.type}
            } else {
                this.sortName = {}
            }

            await this.get()
        },

        copy(text) {
            let result = {}

            try {
                copy(text)
                result.text = text
                result.status = 'success'
                result.icon = 'icon-check'
                result.title = this.$t('notification.success')
            } catch (e) {
                result.text = this.$t('notification.errorMessage')
                result.status = 'danger'
                result.icon = 'icon-alert-circle'
                result.title = this.$t('notification.error')
            }

            if (Object.keys(result).length) {
                this._notification(result.title, result.text, result.status, result.icon)
            }
        },

        async refreshFilter() {
            Object.keys(this.filtersSystem).map(key => {
                this.filtersSystem[key].select = ''
                this.filters[key] = ''
            })

            this.campaign_identifier_system = ''
            this.campaign_identifier = ''

            this.pageNum = 1
            await this.get()
            this.$refs.table.closeExpands()
        },

        changeStatus(status) {
            const sendStatus = async () => {
                try {
                    await send(this.$url.campaigns.destroy, 'DELETE', {data: {id: status.id}})
                    status.is_active = !status.is_active
                } catch (e) {
                    new ErrorHandler(e).send
                }
            }

            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: status.is_active ? this.$t('confirm.deactivateСampaign') : this.$t('confirm.activateСampaign'),
                accept: sendStatus,
                acceptText: status.is_active ? this.$t('buttons.Deactivate') : this.$t('buttons.Activate'),
                cancelText: this.$t('global.Cancel')
            })
        },

        changeDisplay(item) {
            item.display = !item.display
        },

        changeApprove(approve) {
            const sendApprove = async () => {
                try {
                    await send(this.$url.campaigns.approve, 'PUT', {data: {id: approve.id}})
                    approve.is_approved = !approve.is_approved
                } catch (e) {
                    new ErrorHandler(e).send
                }
            }

            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.$t('confirm.Confirm_action'),
                text: approve.is_approved ? this.$t('confirm.approveСampaign') : this.$t('confirm.approveСampaign'),
                accept: sendApprove,
                acceptText: approve.is_approved ? this.$t('buttons.Disapprove') : this.$t('buttons.Approve'),
                cancelText: this.$t('global.Cancel')
            })
        },

        getCode(data) {
            EventBus.$emit('emitPopupEvent', {
                type: 'codeCampaign',
                name: this.$t('global.Information'),
                ids: {...data}
            })
        },

        addCampaign() {
            EventBus.$emit('emitPopupEvent', {type: 'addCampaign', name: this.$t('buttons.Create_campaign'), ids: {}})
        },

        editCampaign(data) {
            EventBus.$emit('emitPopupEvent', {type: 'editCampaign', name: this.$t('modals.Edit_campaign'), ids: {...data}})
        },

        downloadDomains(data) {
            download(
                data.domainsList.join('\n'),
                `${data.affiliate_name}_${Date.now()}.txt`, 'text/plain'
            )
        },

        async submitFilter() {
            const list = Object.entries(this.filtersSystem).reduce((res, [key, value]) => {
                if (value.select !== '' && value.select !== undefined && value.select !== null) res[key] = value
                return res
            }, {})

            this.filters = JSON.parse(JSON.stringify(list))

            this.campaign_identifier = this.campaign_identifier_system
            this.pageNum = 1

            await this.get()
            this.$refs.table.closeExpands()
        },

        getDomains(campaigns, domains) {
            return campaigns.map(campaign => {
                campaign.domainsList = []
                if (campaign.domains && campaign.domains.length) {
                    campaign.domains.map(id => {
                        const domain = domains.find(item => item.id === id)
                        if (domain) {
                            campaign.domainsList.push(domain.name)
                        }
                    })
                }
                return campaign
            })
        },

        createParams() {
            const mutation = (key) => {
                const list = {
                    is_active: 'is_active',
                    is_approved: 'is_approved',
                    languages: 'language',
                    teams: 'team_id',
                    affiliates: 'affiliate_hash',
                    offers: 'offer_id',
                    domains: 'domain_id'
                }

                return list[key]
            }

            const params = {
                page: this.pageNum,
                limit: this.limitNum,
            }

            if (this.campaign_identifier) {
                params.campaign_identifier = this.campaign_identifier
            }

            Object.keys(this.filters).map(key => {
                 params[mutation(key)] = this.filters[key].select
            })

            if (Object.keys(this.sortName).length) {
                Object.assign(params, {...this.sortName})
            }

            return params
        },

        createFilter(data) {
            const createFormat = (array) => {
                return array.map(item => {
                    if (typeof item === "string") {
                        return {id: item, name: item, disabled: true}
                    } else if (Object.isObject(item)) {
                        return {id: item.id, name: item.name, disabled: true}
                    }
                })
            }

            Object.keys(data).map(key => {
                const list = ['is_active', 'is_approved']

                if (list.includes(key)) {
                    data[key] = data[key].map(item => item ? {id: 1, name: 'On', disabled: true} : {id: 0, name: 'Off', disabled: true})
                } else {
                    data[key] = createFormat(data[key])
                }

                if (!this.filtersSystem[key]) {
                    const object = {
                        input: false,
                        select: '',
                        options: data[key]
                    }

                    this.$set(this.filtersSystem, key, {})
                    this.$set(this.filtersSystem, key, object)
                } else {
                    this.filtersSystem[key].options.forEach((item, index) => {
                        const element = data[key].find(a => a.id === item.id)
                        this.filtersSystem[key].options[index].disabled = !!element
                    })
                }

                this.filtersSystem[key].options.sort((a, b) => (a.disabled === b.disabled) ? 0 : a.disabled ? -1 : 1)
            })
        },

        async get() {
            try {
                this.isLoad = true
                const response = await send(this.$url.campaigns.get, 'GET', {params: this.createParams()})
                    .then(response => response.data.result)

                const campaigns = response.data.campaigns.map(item => {
                    if (item.domains) {
                        item.domains = item.domains.map(domain => +domain)
                    }

                    return item
                })

                this.campaignsList = this.getDomains(campaigns, response.data.filters.domains).map(item => {
                    item.team_name = (item.team_name || item.team_id).toString()
                    return item
                })
                this.meta = response.meta

                response.data.filters.teams = this.createNameById(response.data.filters.teams).sort((a, b) => {
                    return a.id > b.id ? 1 : -1
                })

                this.createFilter(response.data.filters)
                this.isLoad = false
                this.isMounted = true
            } catch (e) {
                new ErrorHandler(e).send
            }
        }
    },

    async mounted() {
        await this.get()

        EventBus.$on('emitUpdateCampaigns', async () => {
            await this.get()
        })
    }
}
</script>

<style lang="scss">
.campaigns {
    &.isLoad {
        th {
            pointer-events: none;
            color: gray;
        }
    }
    .ind_color {
        color: #bfbfbf;
    }

    .vs__dropdown-option--disabled {
        background-color: #f6f6f6;
        color: rgba(0,0,0,0.28) !important;
    }
}
</style>
